export default "__VITE_PUBLIC_ASSET__74ef76b2__"